import ApplicationCard from "./applications-card";
import type { ListApplication } from "~/types/application.types";
import NoApplications from "./NoApplications";

type Application = ListApplication;

type ApplicationsListProps = {
  applications: Application[];
  isCollaboratedView?: boolean;
};

export default function ApplicationsList({
  applications,
  isCollaboratedView = false,
}: ApplicationsListProps) {
  if (applications.length === 0) {
    return <NoApplications isCollaboratedView={isCollaboratedView} />;
  }

  return (
    <div className="flex flex-col gap-4">
      {applications.map((application) => (
        <ApplicationCard
          key={application.id}
          application={application}
          isCollaboratedView={isCollaboratedView}
        />
      ))}
    </div>
  );
}
